import React from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { Lock } from 'lucide-react';

const SubMenu = ({ items, onItemClick, isLocked = false }) => {
  const location = useLocation();

  const isSubMenuItemActive = (itemPath) => {
    return location.pathname === itemPath || location.pathname.startsWith(itemPath);
  };

  if (items.length === 0) return null;

  return (
    <div className="ai-submenu">
      {items.map((subItem) => (
        <div key={subItem.id} className={`submenu-item-container ${isLocked ? 'submenu-locked' : ''}`}>
          <div
            className="submenu-item"
            onClick={() => onItemClick(subItem)}
            style={isLocked ? { cursor: 'not-allowed', opacity: 0.5 } : {}}
          >
            <span
              className={`submenu-text ${isSubMenuItemActive(subItem.path) ? 'submenu-active' : ''}`}
            >
              {subItem.text}
            </span>
            {/* 🔒 Show lock icon if locked */}
            {isLocked && (
              <span className="submenu-lock-icon" style={{ marginLeft: 'auto' }}>
                <Lock size={14} />
              </span>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

SubMenu.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired
    })
  ).isRequired,
  onItemClick: PropTypes.func.isRequired,
  isLocked: PropTypes.bool
};

SubMenu.defaultProps = {
  isLocked: false
};

export default SubMenu;